import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { toast } from "sonner";
import { PasswordStrength } from "@/components/PasswordStrength";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/input";
import { AuthLayout } from "@/layouts/AuthLayout";
import { authClient } from "@/lib/auth-client";
import { authErrorMessage } from "./Login";
import { t } from "@shared/i18n";

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(params.get("error") ? t("Ce lien n'est plus valide. Faites une nouvelle demande.") : null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pw.length < 10) return setError(t("10 caractères minimum."));
    if (pw !== confirm) return setError(t("Les deux mots de passe ne correspondent pas."));
    setLoading(true);
    const { error } = await authClient.resetPassword({ newPassword: pw, token: token! });
    setLoading(false);
    if (error) return setError(authErrorMessage(error.code, error.message));
    toast.success(t("Mot de passe modifié. Toutes vos sessions ont été déconnectées par sécurité."));
    navigate("/login", { replace: true });
  };

  return (
    <AuthLayout title={t("Nouveau mot de passe.")} subtitle={t("Choisissez un mot de passe robuste, que vous n'utilisez nulle part ailleurs.")}>
      {!token ? (
        <p className="text-sm text-muted">
          {t("Lien incomplet.")}{" "}
          <Link to="/forgot-password" className="text-primary hover:underline">
            {t("Refaire une demande")}
          </Link>
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label={t("Nouveau mot de passe")}>
            {(p) => <Input {...p} type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} />}
          </Field>
          <PasswordStrength password={pw} />
          <Field label={t("Confirmation")} error={error}>
            {(p) => <Input {...p} type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />}
          </Field>
          <Button type="submit" size="lg" className="w-full" loading={loading}>
            {t("Enregistrer")}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
